var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DIV",
    [
      _c("ItpBox", { attrs: { direction: "row", "align-items": "top" } }, [
        _c(
          "div",
          { staticClass: "mr-2" },
          [
            _c("UcInvoiceTypeBadge", {
              attrs: {
                value: _vm.option.invoice_type,
                kind: _vm.option.invoice_kind,
                advance: _vm.option.is_advance,
                abbreviated: ""
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c("strong", [_vm._v(_vm._s(_vm.option.entry_number))]),
          _vm._v(" "),
          _vm.option.invoice
            ? _c("strong", [
                _vm._v("· " + _vm._s(_vm.option.invoice.invoice_number))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.option.partner
            ? _c("span", [_vm._v("· " + _vm._s(_vm.option.partner.name))])
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_c("br"), _vm._v(_vm._s(_vm.option.subject) + "\n    ")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n    " + _vm._s(_vm._f("date")(_vm.option.entry_date)) + "\n    "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }